/**
 * Minuteur de fin de promotion −10 %.
 *
 * Deux affichages :
 *  - dans la barre d'annonce, une mention compacte ajoutée à la suite du texte
 *    de la diapositive portant la classe « ocl-promo » ;
 *  - sur une fiche produit en promotion, un encart placé juste avant le
 *    formulaire d'achat, là où le client choisit sa variante.
 *
 * À l'échéance, tout disparaît : l'encart, la mention, et la diapositive
 * « ocl-promo » de la barre d'annonce. Aucune intervention à faire le jour J.
 *
 * Pour retirer la promotion : supprimer la ligne qui charge ce fichier dans
 * layout/theme.liquid, puis le fichier lui-même.
 *
 * Script classique, sans import : il ne dépend d'aucun module du thème.
 */
(function () {
  if (window.__oclPromo) return;
  window.__oclPromo = true;

  var FIN = new Date('2026-10-10T23:59:00+02:00').getTime();
  var LIBELLE = 'L’offre de −10 % se termine dans :';

  var minuteur = null;

  function restant() {
    return Math.max(0, Math.floor((FIN - Date.now()) / 1000));
  }

  function deux(n) {
    return n < 10 ? '0' + n : String(n);
  }

  /** « 2 j 10 h 17 min 42 s », sans les unités qui valent zéro en tête. */
  function formate(avecSecondes) {
    var reste = restant();
    var j = Math.floor(reste / 86400);
    var h = Math.floor((reste % 86400) / 3600);
    var m = Math.floor((reste % 3600) / 60);
    var s = reste % 60;

    var bouts = [];
    if (j > 0) bouts.push(j + ' j');
    if (j > 0 || h > 0) bouts.push(deux(h) + ' h');
    bouts.push(deux(m) + ' min');
    if (avecSecondes) bouts.push(deux(s) + ' s');
    return bouts.join(' ');
  }

  function termine() {
    return restant() <= 0;
  }

  /** Masque tout ce qui porte la promotion : la diapositive et l'encart. */
  function effacer() {
    var cibles = document.querySelectorAll('.ocl-promo, [data-ocl-promo-encart]');
    Array.prototype.forEach.call(cibles, function (el) {
      el.style.display = 'none';
    });
    if (minuteur) {
      clearInterval(minuteur);
      minuteur = null;
    }
  }

  /** La mention compacte dans la barre d'annonce. */
  function mentionBarre() {
    var diapos = document.querySelectorAll('.ocl-promo');

    Array.prototype.forEach.call(diapos, function (diapo) {
      var mention = diapo.querySelector('[data-ocl-promo-mention]');

      if (!mention) {
        var hote = diapo.querySelector('p') || diapo.querySelector('.slide') || diapo;
        mention = document.createElement('span');
        mention.setAttribute('data-ocl-promo-mention', '');
        mention.style.cssText = 'white-space:nowrap;';
        hote.appendChild(document.createTextNode(' '));
        hote.appendChild(mention);
      }

      // Sur un écran étroit, la barre tient sur une ligne sans « plus que ».
      var prefixe = window.innerWidth < 560 ? '· ' : '· plus que ';
      mention.textContent = prefixe + formate(false);
    });
  }

  /** L'encart de la fiche produit, inséré une seule fois. */
  function encartFiche() {
    var existant = document.querySelector('[data-ocl-promo-encart]');
    if (existant) {
      var valeur = existant.querySelector('[data-ocl-promo-valeur]');
      if (valeur) valeur.textContent = formate(true);
      return;
    }

    var info = document.querySelector('.product-section__product-info') || document;

    // Uniquement sur un produit réellement en promotion : un prix barré est affiché.
    var barre = info.querySelector('.compare-at-price');
    if (!barre || !barre.textContent.trim()) return;

    var ancre = info.querySelector('product-form-component') || info.querySelector('form[action*="/cart/add"]');
    if (!ancre || !ancre.parentNode) return;

    var encart = document.createElement('div');
    encart.setAttribute('data-ocl-promo-encart', '');
    encart.style.cssText =
      'display:flex;align-items:center;gap:10px;margin:0 0 16px;padding:11px 13px;' +
      'background:#F0E7D8;border-left:2px solid #8A6F4D;border-radius:4px;';

    var icone = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    icone.setAttribute('width', '17');
    icone.setAttribute('height', '17');
    icone.setAttribute('viewBox', '0 0 24 24');
    icone.setAttribute('fill', 'none');
    icone.setAttribute('stroke', '#7A5E38');
    icone.setAttribute('stroke-width', '1.7');
    icone.setAttribute('aria-hidden', 'true');
    icone.style.cssText = 'flex-shrink:0;';
    icone.innerHTML =
      '<circle cx="12" cy="13" r="8"></circle>' +
      '<path d="M12 9v4l2.5 2"></path>' +
      '<path d="M9 2h6"></path>';

    var textes = document.createElement('div');
    textes.style.cssText = 'line-height:1.45;';

    var titre = document.createElement('div');
    titre.style.cssText = 'font-size:11.5px;color:#4A423B;';
    titre.textContent = LIBELLE;

    var valeur = document.createElement('div');
    valeur.setAttribute('data-ocl-promo-valeur', '');
    valeur.style.cssText = 'font-size:13.5px;font-weight:500;color:#1C1815;';
    valeur.textContent = formate(true);

    textes.appendChild(titre);
    textes.appendChild(valeur);
    encart.appendChild(icone);
    encart.appendChild(textes);

    ancre.parentNode.insertBefore(encart, ancre);
  }

  function battement() {
    if (termine()) {
      effacer();
      return;
    }
    mentionBarre();
    encartFiche();
  }

  function demarrer() {
    battement();
    if (!termine() && !minuteur) {
      minuteur = setInterval(battement, 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  // La fiche produit se recompose au changement de variante.
  document.addEventListener('variant:updated', function () {
    setTimeout(battement, 120);
  });
})();
